import React from 'react'
import { BrandLogo, BrandStandards } from '@marketing-milk/interfaces'
import { SurfacePalette } from '../../../tokens'
import { useSectionNumber } from '../../PacketSectionsContext'
import { PresentPage } from '../PresentPage'
import { BrandStandardsContent } from '../../sections/BrandStandardsContent'

interface Props {
  palette: SurfacePalette
  packetID: number
  brandStandards: BrandStandards | null
  brandLogos: BrandLogo[]
}

/**
 * Present-mode (dark) Brand Standards slide. Read-only — editing stays in Edit
 * mode; no in-slide actions, so no nav lock needed.
 */
export const PresentBrandStandardsSection = ({
  palette,
  packetID,
  brandStandards,
  brandLogos,
}: Props) => (
  <PresentPage
    palette={palette}
    number={useSectionNumber('brand-standards')}
    title="Brand Standards"
    accentWord="Standards"
    commentAnchor={{
      type: 'section',
      id: `${packetID}:brand-standards`,
      label: 'Brand Standards',
    }}
  >
    <BrandStandardsContent
      palette={palette}
      brandLogos={brandLogos}
      fonts={brandStandards?.fonts ?? []}
      colors={brandStandards?.colors ?? []}
    />
  </PresentPage>
)
